import Swiper from 'swiper'
import { Autoplay, Pagination, Keyboard } from 'swiper/modules'

import { select } from '@js/util/select'
import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus'

select('[data-slider="default"]', sliderElement => {
  let swiper = new Swiper(sliderElement, {
    modules: [Autoplay, Pagination, Keyboard],
    loop: true,
    threshold: 30,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: 'true',
    },
    keyboard: false,
  })

  const updateSlider = e => {
    console.log(e)
    swiper.updateSize()
  }

  const modal = sliderElement.closest('.modal')

  if (modal) {
    modal.addEventListener('modalOpen', updateSlider)
  }

  function onPrevClick() {
    swiper.slidePrev()
  }
  let prevButton = sliderElement.querySelector('.swiper-button-prev')
  prevButton?.addEventListener('click', onPrevClick)

  // Handle next button
  function onNextClick() {
    swiper.slideNext()
  }
  let nextButton = sliderElement.querySelector('.swiper-button-next')
  nextButton?.addEventListener('click', onNextClick)

  // Handle swiper destroy
  swiper.once('beforeDestroy', () => {
    prevButton?.removeEventListener('click', onPrevClick)
    nextButton?.removeEventListener('click', onNextClick)
  })

  // Keyboard focus is not handled by Swiper.js itself
  swiperHandleKeyboardFocus(swiper)

  return () => {
    swiper.destroy()

    if (modal) {
      modal.removeEventListener('modalOpen', updateSlider)
    }
  }
})
